import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateReport } from "../../models/reports/CreateReport";
import { UpdateReport } from "../../models/reports/UpdateReport";



const RESOURCE_NAME = 'reporting';

const getAll = () => {
  const http = getAxiosInstance(); 
  return http.get(`${RESOURCE_NAME}/getAll`, requestConfig());
};


const create = (model: CreateReport) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/create`, model, requestConfig());
};

const update = (model: UpdateReport) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/update/${model.id}`, model, requestConfig());
};

const remove = (id) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/delete/${id}`, requestConfig());
};


const ReportService = {
  getAll,
  create,
  update,
  remove
};
export default ReportService;
